export default __webpack_public_path__ + "static/media/FontsFree-Net-SFProDisplay-Regular.1e1c0e29.ttf";